const network = require( './network/network_api' );
import {
    RISK_CHOICE,
    RISK_TYPE,
    TYPE,
    processRisk,
    resolveDealerCard,
    isRiskResult,
    proceedRisk,
    stateWinInCoins,
    is_risk_type
} from "./network/network_api";
import { REQUEST_TYPE } from "./network/net";

export default function(
    parent,
    risks
)
{
   
    const space = parent.child( "risk" );
    
    const $request = parent.s( "request" );
    
    //cancel player interaction during network operation which initiated not from within risk:
    const $net = parent.s( "net" );
    $net
        .filter( net =>
            is_risk_type( net.state.type )
            &&
            net.pending == REQUEST_TYPE.PROCEED
        )
        .subscribe( space.s( "collect" ) )
    
    let withinRisk = false;
    
    const $animating = space.s( "animating", false );
    space.s( "startComplete" )
        .map( () => false )
        .to( $animating );
    
    const $startRound = space.s( "startRoundState" );
    $startRound
        .map( state => ({
            //there was bug on a server for a short period which slipped faulty cards into history:
            history : state.server.riskHistoryData.filter( x =>
                (x.hasOwnProperty('nominal') && x.hasOwnProperty('suit') && x.suit < 4) ||
                (x.hasOwnProperty('pos') && x.pos < 2)),
            currentWin : state.server.riskCurrentWin,
            futureWin : state.server.riskFutureWin,
            step : state.server.scenarioData ? state.server.scenarioData.step : 1,
            winFrozen: state.state.win_frozen ? state.state.win_frozen : null,
            processed : processRisk( state.server, state.server.riskState ),
            dealer : resolveDealerCard( state.state ),
            risk_win_queue_credits: state.state.risk_win_queue_credits || []
        }) )
        .subscribe( space.s( "startRound" ) );
    
    const $enter = space.s( "enter" );
    //risk MAIN:
    parent.s( "state" )
        .filter( state => state.type == TYPE.RISK_MAIN )
        .subscribe( state => {
            if ( ! withinRisk )
            {
                $animating.next( true );
                console.log( "enter risk AND start round" );
                withinRisk = true;
                $enter.next( state );
            }
        } )
    
    space.s( "enterComplete" )
        .with( parent.s( "state" ), ( _, state ) => state )
        .to( $startRound );
    
    const $riskResult = parent.s( "state" ).filter( state => isRiskResult( state.state ) );
    
    const $result = space.s( "result" );
    
    //display RESULT:
    $riskResult.subscribe( state =>
    {
        withinRisk = true
        
        $animating.next( true );
        
        $result.next( {
            state,
            result : {
                playerChoise : state.type == TYPE.RISK_RESULT_RED ? 0 : 1,
                winMultiplier: (state.state.stage.win_multiplier) ? state.state.stage.win_multiplier: 0,
                currentWin : stateWinInCoins( state.state ),
                futureWin : stateWinInCoins( state.state ) * ( state.state.risk_possible ? state.state.stage.win_multiplier : 1 ),
                cardSuit : state.state.stage.math.suit,
                cardNominal : state.state.stage.math.nominal,
                processed : processRisk( state.server, state.state ),
                //there was bug on a server for a short period which slipped faulty cards into history:
                history : state.server.riskHistory.filter( x =>
                        (x.hasOwnProperty('nominal') && x.hasOwnProperty('suit') && x.suit < 4) ||
                        (x.hasOwnProperty('pos') && x.pos < 2)),
                step : state.server.scenarioData ? state.server.scenarioData.step : 1,
                winFrozen: state.state.win_frozen ? state.state.win_frozen : null,
                risk_win_queue_credits: state.state.risk_win_queue_credits || []
            }
        } )
    } );

    //delay пока переворачивается карта (плюс кадр между твинами):
    const delayShowRiskWin = (risks.length > 0 && risks[ 0 ].type_id == RISK_TYPE.FIVE_CARDS) ? 1033 : 533
    $result.map(result => stateWinInCoins( result.state.state )).delay(delayShowRiskWin).to( space.s( 'result_win' ) )
    
    const $leave = space.s( "leave" );
    function leave( state )
    {
        if ( ! withinRisk ) return;
        withinRisk = false;
        $leave.next( state );
    }
    
    const $pendingRound = space.s( "pendingRound" );
    $pendingRound
        .map( () => ({ pending : true }) )
        .any( parent.s( "state" ), ( round, state ) => ({ round, state }) )
        .filter( ({ round, state }) => round && round.pending && state.type == TYPE.RISK_MAIN )
        .map( ({ round, state }) => { round.pending = false; return state; } )
        .to( $startRound );
    
    space.s( "showComplete" )
        .withLatestFrom( $riskResult, ( showComplete, state ) => state )
        .subscribe( state =>
        {
            //частично избавляемся от "граблей" проскока риска - пусть сначала завершится анимация проигрыша (проблема "граблей" особенно остро встала из-за выпадения джекпота когда от выпадает как только игрок выбирает проигрышную карту, не успев увидеть что он таки проиграл):
            if ( stateWinInCoins( state.state ) > 0 )
            {
                $pendingRound.next();
                parent.s( "request" ).next( {
                    type : REQUEST_TYPE.CUSTOM,
                    f : () => proceedRisk( state.server, state.state, () => {}, () => {}, () => {} )
                } )
            }
            else
            {
                $animating.next( false )
                /*;
                leave( state );*/
                parent.s( "request" ).next( { type : REQUEST_TYPE.PROCEED } )
            }
        } );
    
    const $choiceIn = space.s( "choiceIn" );
    
    //keyboard:
    if ( risks.length > 1 ) console.error( "At most one type of risk per game is defined for now." );
    //TODO: map input to choice for other types of risks as well:
    const F1    = 112;
    const F2    = 113;
    const F3    = 114;
    const F4    = 115;
    const F5    = 116;
    const F6    = 117;
    let keyMap;
    
    if (risks.length > 0) {
        switch ( risks[ 0 ].type_id )
        {
            case RISK_TYPE.RED_BLACK:
            case RISK_TYPE.LEFT_RIGHT:
                keyMap = {
                    [ F2 ] : RISK_CHOICE.RED,
                    [ F6 ] : RISK_CHOICE.BLACK
                };
                break;
        
            case RISK_TYPE.FIVE_CARDS:
                keyMap = {
                    [ F2 ] : 1,
                    [ F3 ] : 2,
                    [ F4 ] : 3,
                    [ F5 ] : 4
                };
                break;
        
            default:
                console.error( "Undefined risk type." );
                break;
        }
    }

    parent.s( "keyboard" )
        .filter( () => keyMap )
        .map( key => keyMap[ key ] )
        .filter( choice => choice !== undefined )
        .with( parent.s( "state" ), space.s( "choosingCard" ), ( choice, state, choosingCard ) => ({ choice, state, choosingCard }) )
        .filter( ({ state, choosingCard }) => state.type == TYPE.RISK_MAIN && ! choosingCard )
        .map( ({ choice }) => choice )
        .to( space.s( "choiceOut" ) );
    
    space.s( "choiceOut" )
        .with(
            parent.s( "state" ),
            parent.s( "pending" ),
            $animating,
            ( choice, state, pending, animating ) => ({ choice, state, pending, animating })
        )
        .filter( ({ state, pending, animating }) =>
            state.type == TYPE.RISK_MAIN
            &&
            pending === undefined
            &&
            ! animating
        )
        .on( ({ choice }) =>
        {
            $choiceIn.next( choice );
            $request.next( {
                type : REQUEST_TYPE.CHOOSE_AT_RISK,
                userData : {choice: choice},
            } );
        } );
    const $isRisk = parent.s( "state" )
        .combineLatest( $animating, ( state, animating ) => ({ state, animating }) )
        .map( ({ state, animating }) =>
            is_risk_type( state.type )
            ||
            animating
        )
        .distinctUntilChanged();
    $isRisk
        .filter( is => ! is )
        .with( parent.s( "state" ), ( _, state ) => state )
        .on( leave );
    $isRisk.subscribe( parent.s( "isRisk" ) );
    
    $choiceIn
        .map( () => true )
        .merge( space.s( "showComplete" ).map( () => false ) )
        .merge( $startRound.map( () => false ) )
        .subscribe( space.s( "choosingCard", false ) );
    
    //текущая архитектура на callback'ах застревает на состоянии выбора карты при получении ответа от сервера об ограничении выигрыша сразу в RISK_MAIN и интерфейс остаётся навсегда неактивным:
    $isRisk
        .filter( is => ! is )
        .map( () => false )
        .to( space.s( "choosingCard" ) )
    
    //текущая архитектура на callback'ах не позволяет корректно обработать ответ с сервера на лимит выигрыша в RISK_RESULT (это в RISK_MAIN сейчас работает корректно) - застревает на состоянии будто сейчас $animating: решение основывается на том что теперь все анимации должны закончится ПЕРЕД отправкой каких-либо сообщений о переходах на след. стэйджи на сервер (что реализовано ~неделю назад):
    parent.s( "state" )
        .filter( state => ! is_risk_type( state.type ) )
        .map( () => false )
        .to( $animating )

    parent.s( "ui:collect" )
        .withLatestFrom(parent.s( "ui:isRisk" ), (collect, isRisk) => ({collect, isRisk}))
        .filter(({isRisk}) => isRisk)
        .map(({collect}) => collect)
        .to(space.s('collect'));
    
    return space;
}



// WEBPACK FOOTER //
// ./src/library/risk.es6